const getOffsetHeight = (stickyElement) => {
  var _a, _b;
  if (stickyElement) {
    const stickyNestedElement = stickyElement.tagName === "CHC-STICKY-BANNER" ? (_a = stickyElement.shadowRoot) == null ? void 0 : _a.querySelector(".chc-c-sticky-banner") : (_b = stickyElement == null ? void 0 : stickyElement.shadowRoot) == null ? void 0 : _b.querySelector(".chc-c-sticky-anchor-links");
    return stickyNestedElement == null ? void 0 : stickyNestedElement.offsetHeight;
  }
  return 0;
};
const setObserve = (observeElement, observer) => {
  if (observeElement)
    observer.observe(observeElement);
};
const scrollIntoViewWithOffset = (selectorName, offset) => {
  const selector = document.querySelector(selectorName);
  if (selector) {
    const scrollTop = selector.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset;
    window.scrollTo({
      behavior: "smooth",
      top: scrollTop
    });
    document.body.scrollTop = scrollTop;
  }
};
const scrollToAnchor = (clickedHash = "") => {
  if (window.location.hash || clickedHash.length > 1) {
    const URLHash = window.location.hash.substring(1) || clickedHash;
    const leafTabElement = document.querySelector("leaf-tab");
    const stickyElement = document.querySelector("chc-sticky-banner, chc-sticky-anchor-links");
    let scrollDistance = 0;
    if (leafTabElement) {
      return;
    }
    if (stickyElement) {
      scrollDistance = getOffsetHeight(stickyElement);
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].intersectionRatio < 1) {
            scrollDistance = getOffsetHeight(stickyElement);
            scrollIntoViewWithOffset(`*[id="${URLHash}"]`, scrollDistance);
            observer.unobserve(entries[0].target);
          }
        },
        { root: null, threshold: 1 }
      );
      setObserve(stickyElement, observer);
    }
    scrollIntoViewWithOffset(`*[id="${URLHash}"]`, scrollDistance);
  }
};
export {
  scrollIntoViewWithOffset,
  scrollToAnchor
};
//# sourceMappingURL=anchor.js.map
